'use client';
'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const datePicker = require('@zag-js/date-picker');

const datePickerAnatomy = datePicker.anatomy.extendWith("view");

exports.datePickerAnatomy = datePickerAnatomy;
